import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";
import utilityVariables from "ui-v2/styles/utility_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue =
    semanticVariables?.[`semantic_icon_${color}`] ||
    utilityVariables?.[`utility_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.25C9.41414 2.25 6.93419 3.27723 5.10571 5.10571C3.27723 6.93419 2.25 9.41414 2.25 12C2.25 13.2804 2.50219 14.5482 2.99217 15.7312C3.48216 16.9141 4.20034 17.9889 5.10571 18.8943C6.01108 19.7997 7.08591 20.5178 8.26884 21.0078C9.45176 21.4978 10.7196 21.75 12 21.75C13.2804 21.75 14.5482 21.4978 15.7312 21.0078C16.9141 20.5178 17.9889 19.7997 18.8943 18.8943C19.7997 17.9889 20.5178 16.9141 21.0078 15.7312C21.4978 14.5482 21.75 13.2804 21.75 12C21.75 9.41414 20.7228 6.93419 18.8943 5.10571C17.0658 3.27723 14.5859 2.25 12 2.25ZM11.25 16.4419C11.25 16.0277 11.5858 15.6919 12 15.6919H12.008C12.4222 15.6919 12.758 16.0277 12.758 16.4419V16.4499C12.758 16.8641 12.4222 17.1999 12.008 17.1999H12C11.5858 17.1999 11.25 16.8641 11.25 16.4499V16.4419ZM12 6.35531C14.8152 6.35531 12 14.7241 12 14.7241C12 14.7241 9.18476 6.35531 12 6.35531Z"
        fill={colorValue}
      />
    </svg>
  );
};
